export const colorLinkType = {
  KANBAN: 'KANBAN',
  FLAMSTOP_TASKRESOURCEPLANNER: 'FLAMSTOP_TASKRESOURCEPLANNER',
  PROJECT_EMPLOYEE_TASKPLANNER: 'PROJECT_EMPLOYEE_TASKPLANNER',
};
